import { Views, FollowUp, Orgenization, Favourites, Ideas, Business, Holidays, Important, Personal } from '../../../../Constant';
import CreateContact from './CreateContact';
import CategoryCreate from './CategoryCreate';
import { Nav, NavItem } from 'reactstrap';
import React, { Fragment, useState } from 'react';

const NavComponent = ({ callbackActive }) => {
    const [activeTab, setActiveTab] = useState('1');

    return (
        <Fragment>
            <Nav className="main-menu contact-options" role="tablist">
                <NavItem>
                    <CreateContact />
                </NavItem>
                <hr />
                <NavItem>
                    <a href="#javascript" className={activeTab === '1' ? 'active' : ''} onClick={() => {
                        setActiveTab('1'); callbackActive('1');
                    }}><span className="title"> {"All Committees"}</span></a>
                </NavItem>
               
                <NavItem><a href="#javascript" className={activeTab === '2' ? 'active' : ''} onClick={() => {
                    setActiveTab('2'); callbackActive('2');
                }}><span className="title"> {"Scheme Committees"}</span></a></NavItem>
                <NavItem><a href="#javascript" className={activeTab === '3' ? 'active' : ''} onClick={() => {
                    setActiveTab('3'); callbackActive('3');
                }}><span className="title">{"Benefits & Claims Committees"}</span></a></NavItem>
				<NavItem><a href="#javascript" className={activeTab === '4' ? 'active' : ''} onClick={() => {
                    setActiveTab('4'); callbackActive('4');
                }}><span className="title">{"Job Evaluation Committees"}</span></a></NavItem>
				<NavItem><a href="#javascript" className={activeTab === '5' ? 'active' : ''} onClick={() => {
                    setActiveTab('5'); callbackActive('5');
                }}><span className="title">{"Training Evaluation Committees"}</span></a></NavItem>
				
				
                <hr />
            </Nav>
        </Fragment>
    );
};

export default NavComponent;